import { useState } from 'react';
import { downloadBlob, svgToPng } from '../lib/png-browser';

interface Props {
  getSvg: () => SVGSVGElement | null;
  width: number;
  height: number;
  filename?: string;
}

export function DownloadButton({ getSvg, width, height, filename = 'wallpaper.png' }: Props) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onClick = async () => {
    const svg = getSvg();
    if (!svg) return;
    setBusy(true);
    setError(null);
    try {
      const blob = await svgToPng(svg, width, height);
      downloadBlob(blob, filename);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        type="button"
        onClick={onClick}
        disabled={busy}
        className="px-4 py-2 rounded-full bg-zinc-100 text-zinc-900 text-sm font-medium hover:bg-white disabled:opacity-50 transition shadow-lg"
      >
        {busy ? 'rendering…' : `download ${width}×${height} png`}
      </button>
      {error && <span className="text-xs text-red-400 max-w-xs text-right">{error}</span>}
    </div>
  );
}
